import { CHCFooter } from "./footer.component.js";
customElements.define("chc-footer", CHCFooter);
export {
  CHCFooter
};
//# sourceMappingURL=footer.js.map
